import { Action } from '@ngrx/store';
import { ProformaInvoiceApiModel } from '@rocksoft/inroom-sdk';
import { ErrorModel } from '@rocksoft/shared';

export enum MobileFolioActionTypes {
  // Resolver
  MOBILE_FOLIO_RESOLVER_MOBILE_FOLIOS_REQUESTED = '[Mobile folio resolver] Mobile folios requested',

  // Views
  MOBILE_FOLIO_VIEW_SAVE_ORDER = '[Mobile folio view] Save order',

  // API
  MOBILE_FOLIO_API_MOBILE_FOLIOS_LOADED = '[Mobile folio API] Mobile folios loaded',
  MOBILE_FOLIO_API_MOBILE_FOLIOS_LOADED_ERROR = '[Mobile foli API] Mobile folios loaded error',
  MOBILE_FOLIO_API_MOBILE_FOLIO_DELETED = '[Mobile foli API] Mobile folio deleted',
  MOBILE_FOLIO_API_MOBILE_FOLIO_DELETED_ERROR = '[Mobile foli API] Mobile folio deleted error',
  MOBILE_FOLIO_API_MOBILE_FOLIO_UPDATED = '[Mobile foli API] Mobile folio updated',
  MOBILE_FOLIO_API_MOBILE_FOLIO_UPDATED_ERROR = '[Mobile foli API] Mobile folio updated error',
}

export class MobileFolioResolverMobileFoliosRequested implements Action {
  readonly type = MobileFolioActionTypes.MOBILE_FOLIO_RESOLVER_MOBILE_FOLIOS_REQUESTED;

  constructor(public payload: { reservationId: string }) {}
}

// Views
export class MobileFolioViewSaveOrder implements Action {
  readonly type = MobileFolioActionTypes.MOBILE_FOLIO_VIEW_SAVE_ORDER;

  constructor(public payload: { mobileFolio: ProformaInvoiceApiModel }) {}
}

// API
export class MobileFolioApiMobileFoliosLoaded implements Action {
  readonly type = MobileFolioActionTypes.MOBILE_FOLIO_API_MOBILE_FOLIOS_LOADED;

  constructor(public payload: { mobileFolio: ProformaInvoiceApiModel }) {}
}

export class MobileFolioApiMobileFoliosLoadedError implements Action {
  readonly type = MobileFolioActionTypes.MOBILE_FOLIO_API_MOBILE_FOLIOS_LOADED_ERROR;

  constructor(public payload: { error: ErrorModel }) {}
}

export class MobileFolioApiMobileFolioDeleted implements Action {
  readonly type = MobileFolioActionTypes.MOBILE_FOLIO_API_MOBILE_FOLIO_DELETED;

  constructor(public payload: { mobileFolio: ProformaInvoiceApiModel }) {}
}

export class MobileFolioApiMobileFolioDeletedError implements Action {
  readonly type = MobileFolioActionTypes.MOBILE_FOLIO_API_MOBILE_FOLIO_DELETED_ERROR;

  constructor(public payload: { mobileFolio: ProformaInvoiceApiModel; error: ErrorModel }) {}
}

export class MobileFolioApiMobileFolioUpdated implements Action {
  readonly type = MobileFolioActionTypes.MOBILE_FOLIO_API_MOBILE_FOLIO_UPDATED;

  constructor(public payload: { mobileFolio: ProformaInvoiceApiModel }) {}
}

export class MobileFolioApiMobileFolioUpdatedError implements Action {
  readonly type = MobileFolioActionTypes.MOBILE_FOLIO_API_MOBILE_FOLIO_UPDATED_ERROR;

  constructor(
    public payload: {
      originalMobileFolio: ProformaInvoiceApiModel;
      mobileFolio: ProformaInvoiceApiModel;
      error: ErrorModel;
    }
  ) {}
}

export type MobileFoliosActionUnion =
  | MobileFolioResolverMobileFoliosRequested
  // Views
  | MobileFolioViewSaveOrder
  // API
  | MobileFolioApiMobileFoliosLoaded
  | MobileFolioApiMobileFoliosLoadedError
  | MobileFolioApiMobileFolioUpdated
  | MobileFolioApiMobileFolioUpdatedError
  | MobileFolioApiMobileFolioDeleted
  | MobileFolioApiMobileFolioDeletedError;
